import { useEffect } from "react";
import useLogout from "../hooks/useLogout";
import useInitialLoading from "app/hooks/useInitialLoading";
import { useNavigation } from "expo-router";

export function ForceGuestGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useInitialLoading();
  const { logout } = useLogout();
  const { isFocused } = useNavigation();

  useEffect(() => {
    if (isAuthenticated && isFocused()) {
      logout();
    }
  }, [isAuthenticated, logout]);

  return <>{children}</>;
}
